import { PoolExtendDTO, PoolButtonType, PoolButtonStatus } from '@/types/pool';
/**
 * 判断某个按钮是否需要隐藏
 */
export const getButtonIsHidden = (
  type: PoolButtonType,
  poolExtendDTO: PoolExtendDTO
) => {
  return (
    !poolExtendDTO?.poolButtonList ||
    !poolExtendDTO?.poolButtonList?.find((item) => item.name === type) ||
    poolExtendDTO?.poolButtonList?.find((item) => item.name === type)
      ?.status === PoolButtonStatus.Disabled
  );
};

/**
 * 紧急模式，开启时，钱包地址不在whitelist中，对应按钮不展示
 */
export const getBtnEmergencyMode = (
  type: PoolButtonType,
  poolExtendDTO: PoolExtendDTO,
  walletAddress: string
) => {
  if (
    poolExtendDTO?.emergencyMode?.enable &&
    poolExtendDTO?.emergencyMode?.buttons?.includes?.(type)
  ) {
    if (poolExtendDTO?.emergencyMode?.whiteList?.includes(walletAddress)) {
      return false;
    }
    return true;
  }
  return false;
};
